import axios from "axios";
import { handleRequestError } from "../support/ApiUtils";

export const getSDGs = async () => {
  try {
    const base = process.env.REACT_APP_SINCRONIA_BACKEND_URL;
    const resp = await axios.get(`${base}/origen/sdgs`, {
      headers: { "Content-Type": "application/json" },
    });
    return resp.data;
  } catch (err) {
    return handleRequestError(err);
  }
};
